import React, { useEffect } from 'react';
import './ConfirmationModal.css';
import { createModalHandlers, createButtonHandler, preventBodyScroll } from '../utils/modalUtils';

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = 'Confirm Action', 
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  type = 'danger' // danger, warning, info
}) => {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      preventBodyScroll(true);
    } else {
      preventBodyScroll(false);
    }
    return () => {
      preventBodyScroll(false);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    if (onClose) {
      onClose();
    }
  };

  const getIcon = () => {
    switch (type) {
      case 'danger':
        return '🗑️';
      case 'warning':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      default:
        return '❓';
    }
  };

  const overlayHandlers = createModalHandlers(onClose);
  const cancelButtonHandlers = createButtonHandler(onClose);
  const confirmButtonHandlers = createButtonHandler(handleConfirm);

  return (
    <div 
      className="confirmation-modal-overlay" 
      {...overlayHandlers}
    >
      <div 
        className="confirmation-modal-content" 
        onClick={(e) => e.stopPropagation()}
        onTouchStart={(e) => e.stopPropagation()}
        onTouchEnd={(e) => e.stopPropagation()}
      >
        <div className="confirmation-modal-icon">{getIcon()}</div>
        <h3 className="confirmation-modal-title">{title}</h3>
        <p className="confirmation-modal-message">{message}</p>
        <div className="confirmation-modal-actions">
          <button 
            className="confirmation-modal-btn confirmation-modal-btn-cancel"
            {...cancelButtonHandlers}
          >
            {cancelText}
          </button>
          <button 
            className={`confirmation-modal-btn confirmation-modal-btn-confirm confirmation-modal-btn-${type}`}
            {...confirmButtonHandlers}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;




